import { render, staticRenderFns } from "./aminosauren.vue?vue&type=template&id=2999dcfe&"
import script from "./aminosauren.vue?vue&type=script&lang=js&"
export * from "./aminosauren.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports